"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDiscountIdToAmount = void 0;
const mapDiscountIdToAmount = (loyaltyLogs) => {
    const map = new Map();
    for (const loyaltyLog of loyaltyLogs) {
        if (loyaltyLog.discountId) {
            map.set(loyaltyLog.discountId, loyaltyLog.amount);
        }
    }
    return map;
};
exports.mapDiscountIdToAmount = mapDiscountIdToAmount;
//# sourceMappingURL=loyaltyLogsUtils.js.map